<!-- Main Header / Title -->
<h1 class="page-header"><i class="fa fa-print" aria-hidden="true"></i>&nbsp;USERS MMC INFO</h1>

<!-- Rest of the page... -->
<div class="container-fluid">

    <!-- Buttons on top of the table -->
    <div class="page-button">
        <!-- Set Affiliate Button -->
        <button type="button" class="btn btn-ef" 
            [disabled]="isPageBeingChanged || !isAnyItemSelected()"
            (click)="onSetAffiliateClicked()"
            >
            SET MMC AFFILIATE
        </button>

		<div class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<button [disabled]="isPageBeingChanged" type="button" class="btn btn-ef dropdown-toggle" data-toggle="dropdown">
				<em class="fa fa-filter"></em> FILTER <span class="caret"></span>
			</button>
			<ul class="dropdown-menu">
				<li *ngIf="filterValue != null" (click)="removeFilter()"><a>REMOVE FILTER</a></li>
				<li *ngIf="filterValue == null" (click)="addFilter()"><a>User ID</a></li>
			</ul>
		</div>

        <div *ngIf="filterValue != null" class="dropdown btn-group edgefinityHeader" style="display:inline-block">
            User ID
        </div>
        <div *ngIf="filterValue != null" class="dropdown btn-group edgefinityHeader" style="display:inline-block">
            <input [(ngModel)]="filterValue" (ngModelChange)="filterValueChange.next($event)" class="form-control ng-pristine ng-valid ng-untouched" type="text" size="20">
        </div>
		<!--<div *ngIf="filterColumnUser != null" class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			{{ filterColumnNameUser }}
		</div>-->
		<!--<div *ngIf="filterColumnUser != null" class="dropdown btn-group edgefinityHeader" style="display:inline-block">
			<input class="form-control ng-pristine ng-valid ng-untouched" type="text" size="20"
				[(ngModel)]="filterStringUser" (ngModelChange)="filterStringChangedUser()">
		</div>-->
    </div>

    <!-- Table Data -->
    <div class="table-responsive">
        <table class="table tablesorter tablesorter-default table-hover">
            <thead>
                <tr>
                    <th>&nbsp;</th> <!-- Checkbox -->
                    <th width="80px">IMAGE</th>
                    <th>USER ID</th>
                    <th>NAME</th>
                    <th>MMC Affiliate</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let mmcInfo of userMmcInfos | paginate: { id: 'usermmc_pagination', itemsPerPage: pagingPageSize, currentPage: pagingCurrentPageNumber, totalItems: pagingTotalDataCount }">
                    <!-- Checkbox -->
                    <td>
                        <div class="checkbox checkbox-inline">
                            <input type="checkbox" class="styled"
                                (click)="onCheckboxClicked(mmcInfo, $event)"
                                [checked]="isItemSelected(mmcInfo)"
                                [disabled]="isPageBeingChanged"
                                />
                            <label></label>
                        </div>
                    </td>

                    <!-- Image -->
                    <td>
                        <img [src]="getImageSource(mmcInfo)" widt="80" height="80" alt="{{ mmcInfo.user_first_name }} {{ mmcInfo.user_last_name }}" />
                    </td>

                    <!-- User ID -->
                    <td>{{ mmcInfo.user_login }}</td>

                    <!-- Name -->
                    <td>{{ mmcInfo.user_first_name }} {{ mmcInfo.user_last_name }}</td>

                    <!-- MMC Affiliate -->
                    <td>{{ mmcInfo.mmc_affiliate }}</td>
                </tr>
            </tbody>
        </table>
    </div>

	<pagination-controls class="pagination" id="usermmc_pagination"
		(pageChange)="pageChanged($event)" [directionLinks]="true" 
        nextLabel="Next" previousLabel="Prev"
		[autoHide]="true">
	</pagination-controls>

</div>

<!-- Set Affiliate Dialog - Used to prompt the User for the Affiliate Name to assign selected Users. -->
<ef-set-affiliate-dialog
    [possibleAffiliates]="mmcAffiliates"
    (updateClicked)="onSetAffiliateUpdateClicked($event)"
    >
</ef-set-affiliate-dialog>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when updating the Affiliate value for Users. -->
<ef-simple-indefinite-progress-dialog
    >
</ef-simple-indefinite-progress-dialog>